import BaseService from './BaseService'

class AdminUsersService extends BaseService {
  constructor() {
    super('/admin/users')
  }
}

class AdminRolesService extends BaseService {
  constructor() {
    super('/admin/roles')
  }

  async abilities() {
    // Delegate to abilities service
    throw new Error('Use adminAbilitiesService for listing abilities')
  }
}

class AdminAbilitiesService extends BaseService {
  constructor() {
    super('/admin/abilities')
  }

  async listAll() {
    return await this.getAll()
  }
}

export const adminUsersService = new AdminUsersService()
export const adminRolesService = new AdminRolesService()
export const adminAbilitiesService = new AdminAbilitiesService()


